// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3EiVQ","noInteraction":"EventWrapper_noInteraction__3nJKC","pointerPassthrough":"EventWrapper_pointerPassthrough__3_9rw"};